var map = {
	"./bgremover.png": 9938,
	"./crud.png": 7055,
	"./graphql.png": 1007,
	"./kuizzer.png": 1611,
	"./stripe.png": 2012,
	"./testify.png": 9741,
	"./url.png": 5204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1591;